<script>
import app from 'app';

export default {
  render() {
    return this.$slots.default[0];
  },

  props: {
    group: {
      type: String,
      required: true,
      validator(value) {
        return ['discover', 'produced', 'video_modal'].includes(value);
      },
    },
  },

  beforeDestroy() {
    this.removeVolumeListener();
    this.$root.$off('pause-video');
  },

  mounted() {
    const persistGroup = this.getPersistVolume();
    const group = Object.assign(
      this.groupProps,
      _.isNumeric(persistGroup) ? { volume: persistGroup } : {}
    );

    this.groupProps = group;
    this.changeElementVolume(group.volume);
    this.addVolumeListener();

    this.$root.$on('pause-video', () => {
      this.$el?.pause();
    });
  },

  data() {
    return {
      groups: {
        discover: { volume: 0.7 },
        produced: { volume: 0.7 },
        video_modal: { volume: 1 },
      },
    };
  },

  computed: {
    groupProps: {
      get() {
        return this.groups[this.group];
      },

      set(newValue) {
        this.groups[this.group] = newValue;
      },
    },
  },

  methods: {
    changeElementVolume(newVol) {
      this.$el && this.$el.volume && (this.$el.volume = newVol);
    },

    addVolumeListener() {
      this.$el &&
        this.$el.addEventListener('volumechange', this.setPersistVolume);
    },

    removeVolumeListener() {
      this.$el &&
        this.$el.removeEventListener('volumechange', this.setPersistVolume);
    },

    setPersistVolume(e) {
      const newVol = e && e.target && e.target.volume;

      _.isDefined(newVol) &&
        app.stash.set(`volume.groups.${this.group}`, newVol);
    },

    getPersistVolume() {
      return app.stash.get(`volume.groups.${this.group}`);
    },
  },
};
</script>
